const useConsoleLog = () => {
  if (process.env.NODE_ENV === "development") {
    console.log = window.console.log;
  } else {
    console.log = function () {};
  }
};

export default useConsoleLog;
